import React from 'react';
import { useSelector } from 'react-redux';
import StepsContent from '../../components/stepsContent';
import ActionBar from '../../components/actionBar';
import ProgressBar from '../../components/progressBar';
import steps from '../../survey/steps';
import store from '../../store';
import MenuButton from '../../components/menuButton';
import HeaderV2 from '../../components/headerV2';
import SmartHeader from '../../components/smartHeader';
import getParameterFromURL from '../../utils/scripts/getParameterFromURL';
import s from './index.module.scss';
import logo from './img/logo2.png';
// import { customV1 } from '../../survey/configs';

const START_PAGES = new Set([
  'customV1_startPage',
  'customV2_startPage',
  'customV2_policyPage',
  'customV2_policyPageV2',
  'customV2_policyPageV3',
  'customV2_policyPageV4',
  'customV2_policyPageV5',
  'customV2_policyPageV6',
  'customV2_videoPolicyPage',
  'customV2_start_page_video',
  'customV2_startPageV2',
  'customV2_start_page_video_v2',
  'customV2_startPageV3',
  'customV2_startPageV4',
  'customV2_startPageV5',
  'customV2_startPageV6',
  'customV2_startPageV7',
  'customV2_startPageV8',
  'customV2_startPageV11',
  'customV2_startPageV12',
  'customV2_startPageV13',
  'customV2_startPageV17',
  'customV2_startPageV18',
  'customV2_startPageV19',
  'customV2_startPageV20',
  'customV2_startPageV21',
  'customV2_startPageV22',
  'customV2_startPageV23',
  'customV2_startPageV24',
  'customV2_startPageV25',
  'customV2_startPageV26',
  'customV2_startPageV27',
  'customV2_startPageV28',
  'customV2_startPageV29',
  'customV2_startPageV30',
  'customV2_startPageV31',
  'customV2_startPageV32',
  'customV2_startPageV33',
  'customV2_startPageV41',
  'customV2_startPageV34',
  'customV2_startPageV35',
  'customV2_startPageV42',
  'customV2_startPageV43',
  'customV2_startPageV37',
  'customV2_startPageV38',
  'customV2_startPageV36',
  'customV2_startPageV39',
  'customV2_startPageV44',
]);

const SMART_HEADER_CONFIGS = new Set([
  'customV45',
  'customV56',
  'customV48',
  'customV51',
  'customV52',
  'customV55',
  'customV57',
  'customV58',
  'customV59',
  'customV60',
  'customV61',
  'customV62',
  'customV64',
  'customV63',
  'customV65',
  'customV66',
  'customV67',
  'customV68',
  'customV69',
  'customV70',
  'customV71',
  'customV72',
]);

function HeaderButton({ showMenuButton }) {
  const { currentStep } = store.getState().steps;
  const hideElement = currentStep === 'customV1_email';
  const hideClass = hideElement ? s.hideClass : '';

  function goBack() {
    steps.navigate.back();
    steps.userMovedToPreviousStepByClick();
  }

  if (showMenuButton) {
    return (
      <div className={`${s.menuButtonWrapper}`}>
        <MenuButton />
      </div>
    );
  }

  return (
    <button data-prevent-from-blur onClick={goBack} type="button" className={`${s.goBackButton} ${hideClass}`}>
      <div data-prevent-from-blur className={s.goBackButtonContent} />
    </button>
  );
}

function Steps() {
  const showActionBar = useSelector((state) => state.steps.showActionBar);
  const currentStepCompleted = useSelector((state) => state.steps.currentStepCompleted);
  const showMenuButton = useSelector((state) => state.steps.currentStepIndex) === 0;
  const showStartSurveyScreen = useSelector((state) => state.steps.showStartSurveyScreen);
  const menuOpenedClass = useSelector((state) => state.global.menuOpened) ? s.menuOpened : '';
  const transparentBgClass = useSelector((state) => state.global.isStatusBarTransparent) ? s.transparentBg : '';
  const { currentStepIndex } = store.getState().steps;
  const config = useSelector((state) => state.steps.config);
  const showStartSurveyScreenStyle = showStartSurveyScreen ? { visibility: 'hidden' } : {};
  const disableScroll = (currentStepIndex < 4 && config === 'short') ? s.disableScroll : '';
  const customV1Version = getParameterFromURL('config') === 'customV1';
  const customV2Version = getParameterFromURL('config') !== 'customV1';
  const { currentStep } = store.getState().steps;
  const customV1Loader = currentStep === 'customV1_loader';
  const customV1Email = currentStep === 'customV1_email';
  const startPage = START_PAGES.has(currentStep);

  let headerContent = null;
  if (customV2Version) {
    headerContent = SMART_HEADER_CONFIGS.has(config) ? <SmartHeader /> : <HeaderV2 />;
  }

  return (
    <div className={s.page}>
      
      <div className={`${s.contentWrapper} ${disableScroll} stepContentWrapper`} style={showStartSurveyScreenStyle}>
        {customV2Version ? (
          headerContent
        ) : (
          <div className={`${s.header} ${transparentBgClass} ${menuOpenedClass}`}>
            <div className="debug" />
            { (!customV1Loader && !customV1Email && !startPage) && (
              <div className={s.topContent}>
                <HeaderButton showMenuButton={showMenuButton} />
                <ProgressBar />
                <img src={logo} className={s.logo} alt="Everydoggy" />
              </div>
            )}
          </div>
        )}
        <StepsContent />
        <ActionBar show={showActionBar} currentStepCompleted={currentStepCompleted} withShadow={customV1Version} />
      </div>
    </div>
  );
}

export default Steps;
